<template>
  <div class="flex flex-col w-full h-full">
    <AnnouncementBanner :can-dismiss="true" />
    <div class="flex w-full h-full min-h-0">
      <!-- Dynamic sidebar for smaller viewport -->
      <SidebarOverlay
        v-if="windowWidth < 768"
        :is-sidebar-open="sidebarOpen"
        :class="classNames('block md:hidden')"
        @toggle-sidebar="(open) => (sidebarOpen = open)"
      >
        <Sidebar />
      </SidebarOverlay>

      <!-- Static sidebar for large viewport -->
      <div
        :class="
          classNames(
            'hidden overflow-hidden ease-in-out transition-[width] duration-300 md:block',
            sidebarOpen ? 'w-48' : 'w-0',
          )
        "
      >
        <div class="w-48 h-full">
          <Sidebar />
        </div>
      </div>

      <div class="flex flex-col flex-1 w-full min-w-0 h-full">
        <!-- Header -->
        <Topbar :is-sidebar-open="sidebarOpen" @toggle-sidebar="(open) => (sidebarOpen = open)" />

        <!-- Content -->
        <main class="overflow-x-hidden w-full h-full min-w-0 min-h-0 bg-gray-50">
          <slot />
        </main>
      </div>
    </div>
    <ReauthModal />
  </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";

const windowWidth = ref(window.innerWidth);
const sidebarOpen = ref(true);

const updateWidth = () => {
  windowWidth.value = window.innerWidth;
  sidebarOpen.value = window.innerWidth > 1024;
};

onMounted(() => {
  window.addEventListener("resize", updateWidth);
});

onUnmounted(() => {
  window.removeEventListener("resize", updateWidth);
});
</script>
